import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import MsgUtils from '../Tools/MsgUtils';
const server = process.env.REACT_APP_SERVER;

function PrincipalContaduria() {
  const [archivo, setArchivo] = useState(null);
  const [jsonData, setJsonData] = useState("");
  const [lista, setLista] = useState([]);
  function getInformacionNit() {
    fetch(`${server}/reporte/getNitObservados`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'regional': '990'
      })
    })
      .then(res => res.json())
      .then(data => {
        //setLoading(false);
        if (data.ok) {
          setLista(data.ok);
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => MsgUtils.msgError(err));
  }
  function guardarInfo() {
    //setLoading(true);
    fetch(`${server}/reporte/guardarNitObservados`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'regional': '990', 'lista': jsonData
      })
    })
      .then(res => res.json())
      .then(data => {
        //setLoading(false);
        if (data.ok) {
          console.log(data.ok);
        } else {
          MsgUtils.msgError(data.error);
        }
      })
      .catch(err => MsgUtils.msgError(err));
  }
  const handleConvert = () => {
    if (archivo) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);
        setJsonData(JSON.stringify(json, null, 2));
      };
      reader.readAsBinaryString(archivo);
    }
  };
  function buscarNit() {
    // Declare variables
    var input, filter, table, tr, td, i, txtValue;
    input = document.getElementById("myInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("myTable");
    tr = table.getElementsByTagName("tr");

    // Loop through all table rows, and hide those who don't match the search query
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }
  useEffect(() => {
    getInformacionNit()
  }, [])
  return (
    <>
      <div className='container-fluid bg-dark bg-gradient py-1'>
        <div className='row row-cols' style={{marginRight:'40px'}}>
          <div className='col' style={{ minWidth: '250px', maxWidth: '250px' }}>
            <div className="input-group input-group-sm" >
              <span className="input-group-text bg-transparent text-light border-dark">Buscar Nit</span>
              <input type="text" className="form-control form-control-sm" id='myInput' onKeyUp={() => buscarNit()} />
            </div>
          </div>
          {archivo == null &&
            <div className='col' style={{ minWidth: '180px', maxWidth: '180px' }}>
              <div className='input-group input-group-sm' >
                <span className="input-group-text bg-transparent text-light border-dark">Agregar Excel</span>
                <label className='btn btn-sm text-success'>
                  <i className="fa-solid fa-file-circle-plus fa-2xl"></i>
                  <input type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={(e) => setArchivo(e.target.files[0])} />
                </label>
              </div>
            </div>}
          {archivo != null && jsonData == '' &&
            <div className='col' style={{ minWidth: '100px', maxWidth: '100px' }}>
              <button className='btn btn-sm btn-info w-100' onClick={() => handleConvert()}>Convertir</button>
            </div>}
          {archivo != null && jsonData !== '' && 
          <div className='col' style={{ minWidth: '100px', maxWidth: '100px' }}>
            <button className='btn btn-sm btn-info w-100' onClick={() => guardarInfo()}>Guardar</button>
            </div>}
        </div>
      </div>
      <div className='table-responsive'>
        <table className="table table-dark table-striped table-hover table-sm" id='myTable'>
          <thead>
            <tr>
              <th>Nit</th>
              <th>Razon Social</th>
            </tr>
          </thead>
          <tbody>
            {lista.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{item.NIT}</td>
                  <td>{item.RAZON_SOCIAL}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </>
  )
}

export default PrincipalContaduria